package com.wintermar.inspection.feature.presentation.inspection.answer.widget.guidance

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.LinkText
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_down
import inspection.composeapp.generated.resources.ic_arrow_up

@Composable
fun Guidance(
    question: String,
    guidance: String,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    var expanded by remember { mutableStateOf(false) }
    var isTruncated by remember { mutableStateOf(false) }

    LazyColumn(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
    ) {
        item {
            Column(
                modifier = Modifier.padding(horizontal = dimension.spacing.space5),
                verticalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
            ) {
                TextBodySmall(text = "Question", bold = true)
                TextBodySmall(
                    text = question,
                    modifier = Modifier.animateItem(),
                    maxLines = if (expanded) Int.MAX_VALUE else 3,
                    onTextLayout = { textLayoutResult ->
                        if (!expanded) {
                            isTruncated = textLayoutResult.hasVisualOverflow
                        }
                    }
                )
                if (isTruncated || expanded) {
                    LinkText(
                        text = if (expanded) "Hide" else "Expand",
                        icon = if (expanded) Res.drawable.ic_arrow_up else Res.drawable.ic_arrow_down,
                        modifier = Modifier.animateItem(),
                        onClick = {
                            expanded = !expanded
                        })
                }
            }

            HorizontalDivider(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(vertical = dimension.spacing.space2),
                color = color.border.subtle
            )

            Column(
                modifier = Modifier.padding(horizontal = dimension.spacing.space5),
                verticalArrangement = Arrangement.spacedBy(dimension.spacing.space2)
            ) {
                TextBodySmall(text = "Guidance", bold = true)

                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(
                            color = color.surface.neutral.subtlest.default,
                            shape = RoundedCornerShape(dimension.radius.md)
                        )
                        .border(
                            width = 1.dp,
                            color = color.border.subtle,
                            shape = RoundedCornerShape(dimension.radius.md)
                        )
                        .padding(dimension.spacing.space3)
                ) {
                    TextBodySmall(text = guidance, modifier = Modifier.animateItem())
                }
            }
        }
    }
}
